import React from 'react';
import useEducators from './useEducators';

export default function useSleepingPartners(network, schoolStart, schoolEnd, currentTimestamp) {
  return useEducators(network, schoolStart, schoolEnd, {
    sleepingStartingAt: {
      $lte: currentTimestamp
    },
    sleepingEndingAt: {
      $gte: currentTimestamp
    },
    inactive: false
  });
}
